import AnatomyV2LearningProfile from '~/pages/anatomyV2/learningProfile/libs/components/AnatomyV2LearningProfile'
import { TPageProps } from '~/shared/types/commonTypes'

const LearningProfileAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2LearningProfile {...props} />
)

export default LearningProfileAnatomyV2
